import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'DashboardRegistAdminNoticeModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      proccesing: false,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.dashboardRegistAdminNoticeModal.active,

      // model
      serviceModel: state => state.dashboardRegistAdminNoticeModal.serviceModel,
      values: state => state.dashboardRegistAdminNoticeModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // list
    serviceList () {
      //TODO v1ServiceListGetのレスポンス
      let list = [{
        label: '全てのサービス',
        value: ''
      }]
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        label: item.serviceName,
        value: item.serviceUuid
      }))
      return list
    },

    // input
    inpTargetServiceUuid: {
      get () {
        return this.values.inpTargetServiceUuid
      },
      set (value) {
        this.setInputValue({
          key: 'inpTargetServiceUuid',
          value: value
        })
      }
    },
    inpTitle: {
      get () {
        return this.values.inpTitle
      },
      set (value) {
        this.setInputValue({
          key: 'inpTitle',
          value: value
        })
      }
    },
    inpMessage: {
      get () {
        return this.values.inpMessage
      },
      set (value) {
        this.setInputValue({
          key: 'inpMessage',
          value: value
        })
      }
    },
    inpSignature: {
      get () {
        return this.values.inpSignature
      },
      set (value) {
        this.setInputValue({
          key: 'inpSignature',
          value: value
        })
      }
    },

    // validate
    inpTitleIsValid () {
      return Validator.validText(this.inpTitle)
    },
    inpMessageIsValid () {
      return Validator.validText(this.inpMessage)
    },
    inpSignatureIsValid () {
      return Validator.validText(this.inpSignature)
    },
    formIsValid () {
      return this.inpTitleIsValid &&
        this.inpMessageIsValid &&
        this.inpSignatureIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'dashboardRegistAdminNoticeModal/loadModel',
      hide: 'dashboardRegistAdminNoticeModal/hide',
      setUpdated: 'dashboardRegistAdminNoticeModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'dashboardRegistAdminNoticeModal/setInputValue',
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      //
      let serviceParams = {}

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容でお知らせを配信しますか？',
        acceptLabel: '送信'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        request: {
          title: this.inpTitle,
          message: this.inpMessage,
          signature: this.inpSignature,
        }
      }
      if (this.inpTargetServiceUuid) {
        parameters.request.serviceUuid = this.inpTargetServiceUuid
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['adminNotice'],
        ['v1AdminNoticePost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'サービス担当者へのお知らせの登録',
              body: '「' + this.inpTitle + '」を配信しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}